document.addEventListener("DOMContentLoaded", function() {
  const banner = document.querySelector(".bannerz");
  if (!banner) return;

  const slider = banner.querySelector(".slider");
  const items  = banner.querySelectorAll(".item");
  const titleEl = banner.querySelector(".bannerz__current-title");
  const descrEl = banner.querySelector(".bannerz__current-descr");
  const imgEl = banner.querySelector(".bannerz__img");
  const panel = banner.querySelector(".bannerz__panel");
  const panelInner = banner.querySelector("[data-panel-inner]");
  const infoBtn = document.querySelector("[data-panel-toggle]");
  const infoTitleEl = banner.querySelector("[data-panel-info-title]");
  const infoDescrEl = banner.querySelector("[data-panel-info-desc]");
  const infoImgEl = banner.querySelector("[data-panel-info-img]");
  const infoCtaEl = banner.querySelector("[data-panel-info-cta]");
  const cta = document.querySelector("#carousel_cta");
  if (!slider || !items.length) return;

  // Read count from CSS if present, else fallback to items length
  const cssCount = parseInt(getComputedStyle(slider).getPropertyValue("--count"), 10);
  const total = !isNaN(cssCount) && cssCount > 0 ? cssCount : items.length;
  const anglePer = 360 / total;

  function lerpSize(w, minW = 607, maxW = 1920, minY = 5.9, maxY = 9.65) {
    const t = (w - minW) / (maxW - minW);
    const tClamped = Math.min(1, Math.max(0, t));
    return minY + (maxY - minY) * tClamped;
  }
  const FRONT_OFFSET = lerpSize(window.innerWidth);//9.65; 

  let t = 0;                    // master rotation (deg) -> sets --t
  let isDragging = false;
  let dragStartX = 0;
  let dragStartT = 0;
  let autoTimer = null;
  let snapping = false;
  let hovering = false;

  const DRAG_FACTOR = 0.3;      // lower = slower drag
  const AUTO_DELAY = 2500;      // ms between auto steps
  let isFlipped = false;

  const normalize = (a) => {
    a = a % 360;
    if (a > 180) a -= 360;
    if (a < -180) a += 360;
    return a;
  };

  const setT = (deg) => {
    t = deg;
    slider.style.setProperty("--t", `${deg}deg`);
    updateItemOffsets();
  };

  const getNearestIndex = () => {
    const norm = normalize(t);
    let idx = Math.round(-norm / anglePer);
    idx = ((idx % total) + total) % total;
    return idx;
  };

  const smoothSnapTo = (targetDeg, cb) => {
    if (snapping) return;
    snapping = true;

    const start = t;
    const diff = normalize(targetDeg - start);
    const duration = 400;
    const startTime = performance.now();

    const step = (now) => {
      const p = Math.min((now - startTime) / duration, 1);
      // ease in-out
      const ease = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
      setT(start + diff * ease);

      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        snapping = false;
        if (cb) cb();
      }
    };

    requestAnimationFrame(step);
  };

  const wrapIdx = (idx) => ((idx % total) + total) % total;

  const animateSwap = (el, value) => {
    if (!el) return;
    if (el.textContent === value) return;
    el.classList.add("is-changing");
    setTimeout(() => {
      el.textContent = value;
      el.classList.remove("is-changing");
    }, 180);
  };

  const animateSwapIMG = (el, value) => {
    if (!el) return;
    if (el.src === value) return;
    el.src = value;
    var cleanSrc = el.src.replace(/([?&])width=\d+/g, '').replace(/[?&]$/, '');
    function withWidth(url, width) {
      return url + (url.includes('?') ? '&' : '?') + 'width=' + width;
    }
    //el.setAttribute('src', withWidth(cleanSrc, 420));
    el.setAttribute(
      'srcset',
      [
        withWidth(cleanSrc, 200) + ' 200w',
        withWidth(cleanSrc, 280) + ' 280w',
        withWidth(cleanSrc, 350) + ' 350w',
        withWidth(cleanSrc, 420) + ' 420w',
        withWidth(cleanSrc, 560) + ' 560w',
        withWidth(cleanSrc, 700) + ' 700w'
      ].join(', ')
    );
    el.setAttribute('sizes', '(max-width: 749px) calc(100vw - 40px), 350px');
  };
  const setText = (el, value) => {
    if (!el) return;
    el.textContent = value || '';
  };

  const updateTextsForIndex = (idx) => {
    const safeIdx = wrapIdx(idx);
    const activeItem = items[safeIdx];
    if (!activeItem) return;
    animateSwap(titleEl, activeItem.dataset.title || "");
    animateSwap(descrEl, activeItem.dataset.descr || "");
    animateSwapIMG(imgEl, activeItem.dataset.imgsrc || "");
    cta.setAttribute('href', activeItem.dataset.url);
    setText(infoTitleEl, activeItem.dataset.infoTitle || activeItem.dataset.title || "");
    setText(infoDescrEl, activeItem.dataset.infoDesc || "");
    if (infoImgEl && activeItem.dataset.infoImg) {
      infoImgEl.src = activeItem.dataset.infoImg;
      infoImgEl.alt = activeItem.dataset.infoTitle || activeItem.dataset.title || "";
    }
    if (infoCtaEl && activeItem.dataset.url) {
      infoCtaEl.href = activeItem.dataset.url;
    }
  };

  const updateItemLayers = (idx) => {
    const primary = wrapIdx(idx);
    const near = [
      wrapIdx(idx - 1),
      wrapIdx(idx + 1),
      wrapIdx(idx - 2),
      wrapIdx(idx + 2),
    ];

    items.forEach((item, i) => {
      item.classList.remove("is-current", "is-near");
      if (i === primary) {
        item.classList.add("is-current");
      } else if (near.includes(i)) {
        item.classList.add("is-near");
      }
    });
  };

  const snapToIndex = (idx, cb) => {
    const target = -idx * anglePer + FRONT_OFFSET;
    updateTextsForIndex(idx);
    smoothSnapTo(target, () => {
      updateItemLayers(idx);
      if (cb) cb();
    });

    items.forEach((item, i) => {
      item.classList.remove("is-next", "is-current");
    });
    items[idx].classList.add("is-next");
  };

  const getEllipseHeight = () => {
    const raw = parseFloat(getComputedStyle(slider).getPropertyValue('--ellipse-height'));
    return isNaN(raw) ? 0 : raw;
  };

  const updateItemOffsets = () => {
    const ellipseHeight = getEllipseHeight();
    const toRad = Math.PI / 180;
    items.forEach((item, idx) => {
      const angleDeg = anglePer * idx + t;
      const yOffset = Math.cos(angleDeg * toRad) * ellipseHeight;
      item.style.setProperty('--y-offset', `${yOffset}px`);
    });
  };

  const goToNext = (override = false) => {
    if (isDragging || snapping || hovering) return;
    
    let current = getNearestIndex();
    let next = (current - 1 + total) % total; // rotate forward one
    
    snapToIndex(next);
  };

  const startAutoplay = (immediate = false) => {
    stopAutoplay();
    if (immediate) {
      goToNext();
    }
    autoTimer = setInterval(goToNext, AUTO_DELAY);
  };

  const stopAutoplay = () => {
    if (autoTimer) {
      clearInterval(autoTimer);
      autoTimer = null;
    }
  };

  // ----- DRAG / SWIPE via pointer events -----
  const endDrag = (e) => {
    if (!isDragging) return;
    isDragging = false;
    if (e && e.pointerId != null) {
      slider.releasePointerCapture(e.pointerId);
    }
    const idx = getNearestIndex();
    snapToIndex(idx, () => {
      startAutoplay();
    });
  };

  banner.addEventListener("pointerdown", (e) => {
    if (isDragging || snapping) return;

    // ignore taps on items (handled above)

    const rect = banner.getBoundingClientRect();
    const x = e.clientX - rect.left;

    stopAutoplay();

    if (x < rect.width / 2) {
      snapToIndex((getNearestIndex() - 1 + total) % total, startAutoplay);
    } else {
      snapToIndex((getNearestIndex() + 1 + total) % total, startAutoplay);
    }
  });

  banner.addEventListener("pointermove", (e) => {
    if (!isDragging) return;
    const dx = e.clientX - dragStartX;
    setT(normalize(dragStartT + dx * DRAG_FACTOR));
  });

  banner.addEventListener("pointerup", endDrag);
  banner.addEventListener("pointercancel", endDrag);
  banner.addEventListener("pointerleave", endDrag);
  banner.addEventListener("mouseenter", () => {
    hovering = true;
    stopAutoplay();
  });
  banner.addEventListener("mouseleave", () => {
    hovering = false;
    startAutoplay();
  });

  /* Optional: click on item to center it
  items.forEach((item, index) => {
    item.addEventListener("click", () => {
      if (isDragging) return;
      stopAutoplay();
      snapToIndex(index, () => startAutoplay());
    });
  });*/

  // Init
  setT(0);
  const initialIdx = getNearestIndex();
  updateTextsForIndex(initialIdx);
  updateItemLayers(initialIdx);
  startAutoplay(true);

  if (infoBtn && panel) {
    infoBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      isFlipped = !isFlipped;
      panel.classList.toggle('is-flipped', isFlipped);
    });
  }

});
